import React, { memo, useState, useContext } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { UserContext } from "../../../../../../contexts/User";
import { SettingsContext } from "../../../../../../contexts/Settings";
import { toast } from "react-toastify";
//functions
import {
  _t,
  getCookie,
  currencySymbolLeft
  // restaurantMenuLink,
} from "../../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { BASE_URL } from "../../../../../../BaseUrl";
import DatePicker from "react-datepicker";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const PosModal = ({
  emptyCard,
  cashDetails,
  setCashDetails,
  setBackModal,
  backModal,
  paymentTypeAvailable,
  handleCardSubmit,
  setOrderDetails,
  orderDetails,
  cardModal,
  noteRiderModal,
  setNoteRiderModal,
  handleSubmitOrder,
  handlePreOrder,
  handlePunchOrder
}) => {
  // PACKAGES SETTINGS OBJECT
  const toastObj = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };
  const { t } = useTranslation();
  const { loading, setLoading,} = useContext(SettingsContext);
  const { partyForSearch } = useContext(UserContext);

  const confirmPunchOrder = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <>
            <style>
              {`
                .react-confirm-alert-overlay {
                  z-index: 999999 !important;
                }
              `}
            </style>
            <div className="card custom-confirm-alert rounded-sm shadow-sm">
              <div className="card-body px-5 py-4">
              <h5 className="font-weight-bold mb-3">{_t(t("Are you sure?"))}</h5>
              <p className="text-muted mb-4">{_t(t("Are you sure you want to punch this order?"))}</p>
              <div className="d-flex justify-content-end gx-2 mt-4">
                <button className="btn btn-secondary mr-2" onClick={onClose}>
                  {_t(t("No"))}
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    handlePunchOrder();
                    onClose();
                  }}
                  disabled={loading}
                >
                  {_t(t("Yes"))}
                </button>
              </div>
            </div>
          </div>
          </>
        );
      },
    });
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      Delivered: "badge bg-primary",
      Processing: "badge bg-info",
      Cancelled: "badge bg-red",
    };
    const statusBadge = (status?.is_cancelled || status?.is_refund) ? "Cancelled" : (status?.is_paid ? "Delivered" : "Processing");
    return statusClasses[statusBadge] || "badge";
  };

  // pay in/out
  const [otherChequeFields, setOtherChequeFields] = useState(false);
  const focusPopUpInputField = (input) => {
    if (input) {
      input.focus()
    }
  };
  //  party
  const handleSetPartyFromCashModal = (party) => {
    setCashDetails({
      ...cashDetails,
      party_id: party.id,
      party_name: party.name,
    });
  };
  
  //cash modal
  const handleSubmitCash = (type) => {
    let url = BASE_URL + "/settings/new-payment";
    setLoading(true);
    console.log("cash detail : ", cashDetails);
    if (!cashDetails.payment_type) {
      toast.error(`${_t(t("Please add payment type"))}`, toastObj);
      setLoading(false);
      return false;
    } else {
      let formData = cashDetails;
      formData.payment_status = type;

      axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          toast.success(
            `${_t(t("Record has been added successfully."))}`,
            toastObj
          );
          setLoading(false);
          setCashDetails({
            ...cashDetails,
            party_id: "",
            party_name: "",
            payment_type: false,
            cheque_no: 0,
            cheque_date: null,
            payment_status: null,
            remarks: "",
            amount: 0,
          });
        })
        .catch(() => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, toastObj);
        });
    }
  };

  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const selectedDate = orderDetails.pre_order_date;
  const isToday = ((selectedDate && selectedDate.toDateString()) || now.toDateString()) === now.toDateString();;
  const minTime = isToday ? now : startOfToday; 
  const endOfDay =  new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    45
  );

  return (
    <>
      {/* Cash Modal */}
      <div style={{ zIndex: 1039 }} className="modal fade" id="cashModal" aria-hidden="true">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content"></div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form autoComplete="off">
                  <div>
                    <div className="addons-list__item mt-1 mx-1">
                      <Select
                        options={partyForSearch && partyForSearch}
                        components={makeAnimated()}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        classNamePrefix="select"
                        className="xsm-text"
                        onChange={handleSetPartyFromCashModal}
                        maxMenuHeight="200px"
                        placeholder={_t(t("Select Party")) + ".."}
                      />
                    </div>

                    <div className="addons-list__item mt-1 mx-1 mb-1 fk-addons-table__body">
                      <label htmlFor="name" className="form-label d-block">
                        {_t(t("Payment Type"))}{" "}
                        <small className="text-primary">*</small>
                      </label>
                      <label className="mx-checkbox d-inline-block mr-3">
                        <input
                          type="radio"
                          value="Cash"
                          className="mx-checkbox__input mx-checkbox__input-solid mx-checkbox__input-solid--danger mx-checkbox__input-sm"
                          name="payment_type"
                          onChange={() => {
                            setOtherChequeFields(false);
                            setCashDetails({
                              ...cashDetails,
                              payment_type: "Cash",
                            });
                          }}
                        />
                        <span className="mx-checkbox__text text-capitalize t-text-heading t-ml-8 fk-addons-table__body-text">
                          Cash
                        </span>
                      </label>
                      <label className="mx-checkbox d-inline-block mr-3">
                        <input
                          type="radio"
                          value="Cheque"
                          className="mx-checkbox__input mx-checkbox__input-solid mx-checkbox__input-solid--danger mx-checkbox__input-sm"
                          name="payment_type"
                          onChange={() => {
                            setOtherChequeFields(true);
                            setCashDetails({
                              ...cashDetails,
                              payment_type: "Cheque",
                            });
                          }}
                        />
                        <span className="mx-checkbox__text text-capitalize t-text-heading t-ml-8 fk-addons-table__body-text">
                          Cheque
                        </span>
                      </label>
                    </div>
                    <div
                      className={`others-cheque-fields
                       ${otherChequeFields && "active"}
                      `}
                    >
                      <div className="addons-list__item mt-1 mx-1">
                        <label htmlFor="name" className="form-label d-block">
                          {_t(t("Enter Cheque No."))}{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cheque_no"
                          name="cheque_no"
                          placeholder="Enter Cheque No."
                          value={cashDetails.cheque_no}
                          onChange={(e) => {
                            setCashDetails({
                              ...cashDetails,
                              cheque_no: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div className="addons-list__item mt-1 mx-1 mb-3">
                        <label htmlFor="name" className="form-label d-block">
                          {_t(t("Enter issue cheque date"))}{" "}
                        </label>
                        <DatePicker
                          selected={cashDetails.cheque_date}
                          onChange={(date) => {
                            setCashDetails({
                              ...cashDetails,
                              cheque_date: date,
                            });
                          }}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control sm-text py-2 t-mb-15 mb-md-0"
                          placeholderText={_t(t("Enter issue cheque date"))}
                          shouldCloseOnSelect={false}
                        />
                      </div>
                    </div>
                    <div className="addons-list__item mt-1 mx-1">
                      <label htmlFor="name" className="form-label d-block">
                        {_t(t("Enter Amount"))}{" "}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="name"
                        name="name"
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "-"].includes(evt.key) &&
                          evt.preventDefault()
                        }
                        placeholder="Enter Amount"
                        value={cashDetails.amount}
                        required
                        onChange={(e) => {
                          setCashDetails({
                            ...cashDetails,
                            amount: e.target.value,
                          });
                        }}
                      />
                    </div>

                    <div className="addons-list_item mt-1 mx-1">
                      <textarea
                        name="remarks"
                        className="form-control"
                        placeholder="Remarks"
                        value={cashDetails.remarks}
                        onChange={(e) => {
                          setCashDetails({
                            ...cashDetails,
                            remarks: e.target.value,
                          });
                        }}
                      ></textarea>
                    </div>
                  </div>

                  <div className="mt-4">
                    <div className="row">
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-success font-weight-bold w-100 sm-text text-uppercase t-width-max"
                          onClick={(e) => handleSubmitCash("pay-in")}
                          data-dismiss={`${
                            cashDetails.payment_type ? "modal" : ""
                          }`}
                        >
                          {_t(t("Pay-in"))}
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-primary font-weight-bold w-100 sm-text text-uppercase t-width-max"
                          data-dismiss={`${
                            cashDetails.payment_type ? "modal" : ""
                          }`}
                          onClick={(e) => handleSubmitCash("pay-out")}
                        >
                          {_t(t("Pay out"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*back btn Modal*/}
      <div
        style={{ zIndex: 1039 }} 
        className={`modal fade ${backModal !== false ? "showing" : ""}`}
        id="cartEmpty"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-body">
              {/* show form or show saving loading */}
              <form onSubmit={(e) => e.preventDefault()} autoComplete="off">
                <div>
                  <h2 htmlFor="name" className="form-label text-center my-2">
                    Are you sure?
                  </h2>
                  <p className="text-center mt-1 mb-4">
                    You want to cancel this order
                  </p>
                </div>

                <div className="mt-3 mb-1">
                  <div className="row d-flex justify-content-center w-100 m-0">
                    <div className="col-3 mr-1">
                      <button
                        type="button"
                        className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded-25"
                        data-dismiss="modal"
                        onClick={emptyCard}
                      >
                        {_t(t("Yes"))}
                      </button>
                    </div>
                    <div className="col-3 ">
                      <button
                        type="button"
                        className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded-25"
                        data-dismiss="modal"
                        onClick={(e) => {
                          setBackModal(false);
                        }}
                      >
                        {_t(t("No"))}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Card Modal */}
      <div
        style={{ zIndex: 1039 }} 
        className="modal fade"
        ref={cardModal}
        id="cardModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content" style={{ borderRadius: "1rem" }}>
            {/* <div className="modal-header align-items-center">
              <div className="fk-sm-card__content"></div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div> */}
            <div className="modal-body py-4">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form autoComplete="off" onSubmit={(e) => {
                    e.preventDefault();
                    handleCardSubmit(e);
                  }}
                >
                  
                  <div className="addons-list__item mt-1 mx-1">
                    <label
                      htmlFor="name"
                      className="form-label d-flex justify-content-between"
                    >
                      <span>{_t(t("Enter Card Number"))} </span>
                      <span
                        onClick={(e) => {
                          cardModal.current.classList.remove("showing");
                          setOrderDetails((curr)=>{
                            const newData = {
                            ...curr,
                            discount: 0,
                            card_number: "",
                            payment_discount: null,
                            payment_dis_type:"",
                            scheme: {
                              scheme_id: null,
                              scheme_name: "",
                              cap_amount: 0,
                              discount_amount: 0,
                              sharing_with_party: 0,
                              open_discount: null,
                              discount_type: "",
                              how_much_discount: null,
                              discount_addon: "",
                            },
                            }
                            return newData
                          });
                          //setSchemeForSearchObj(null);
                        }}
                      >
                        <i className="fa fa-times-circle close-1 pointer-cursor"></i>
                      </span>
                    </label>
                    <input
                      ref={focusPopUpInputField}
                      type="text"
                      onWheel={(e) => e.target.blur()}  
                      min="0"
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="Enter Card Number"
                      autoComplete="off"
                      maxLength={16}
                      value={orderDetails.card_number}
                      required
                      onChange={(e) => {
                        const value = e.target?.value ?? "";
                        setOrderDetails((curr)=>({
                          ...curr,
                          card_number: value,
                        }));
                      }}
                    />
                  </div>

                  <div className="addons-list__item mt-1 mx-1">
                    <label
                      htmlFor="name"
                      className="form-label d-flex justify-content-between"
                    >
                      <span>{_t(t("Payment Type"))} <span className="text-danger table-text">(Select tax on discount by payment type.)</span> </span>
                    </label>
                    <div className="row bill_modal_scroll" style={{maxHeight: "8rem"}}>
                      {paymentTypeAvailable && paymentTypeAvailable.map((payment, index)=>{
                          if(payment.name.toLowerCase() !== "cash"){
                            return (
                              <div key={index} className="col-4 text-truncate my-1">
                                <input
                                  className="form-check-input pointer-cursor"
                                  type="radio"
                                  id={payment.name}
                                  name="payment_discount"
                                  value={payment.name}
                                  checked={orderDetails.payment_dis_type === payment.name}
                                  onChange={(e) => setOrderDetails((curr)=>({...curr, payment_dis_type: payment.name,  payment_discount: payment?.name ? orderDetails.branch?.payment_tax[payment.name] : null}))}
                                />
                                <label
                                  className="form-radio-label d-inline pointer-cursor ml-1"
                                  htmlFor={`${payment.name}`}
                                >
                                  {_t(t(`${payment.name}`))}
                                </label>
                              </div>  
                            )
                          }
                        })
                      }
                    </div>
                  </div>

                  <div className="mt-4">
                    <div className="row">
                      <div className="col-12 px-3">
                        <button
                          type="submit"
                          disabled={loading}
                          className="btn btn-success font-weight-bold w-100 sm-text text-uppercase t-width-max"
                        >
                          {_t(t("Add Card"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*note to rider Modal*/}
      <div
        style={{ zIndex: 1039 }} 
        className={`modal fade ${noteRiderModal !== false ? "showing" : ""}`}
        id="riderNote"
        aria-hidden="true"
      >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header align-items-center">
            <div className="fk-sm-card__content"></div>
            <button
            type="button"
            className="btn-close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={(e) => setNoteRiderModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            {/* show form or show saving loading */}
            <form onSubmit={(e) => {
            e.preventDefault();
            setNoteRiderModal(false)
            }}autoComplete="off">
              <label htmlFor="noteToRider" className="form-label">
                Note <span style={{color:"red"}}>*</span>
              </label>
              <input
                ref={focusPopUpInputField}
                type="text"
                className="form-control"
                name = 'noteToRider'
                id = 'noteToRider'
                placeholder="note"
                autoFocus
                required
                value={orderDetails.note_to_rider || ""}
                onChange={(e)=>{
                  setOrderDetails({
                    ...orderDetails,
                    note_to_rider: e.target.value,
                  })
                }}
              />

              <div className="mt-3 mb-1">
                <div className="row d-flex justify-content-center w-100 m-0">
                  <div className="col-3 mr-1">
                    <button
                      type="submit"
                      className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded-25"
                      data-dismiss="modal"
                    >
                      {_t(t("Submit"))}
                    </button>
                  </div>
                  <div className="col-3 ">
                    <button
                      type="button"
                      className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded-25"
                      data-dismiss="modal"
                      onClick={(e) => {
                      setNoteRiderModal(false);
                      setOrderDetails({
                        ...orderDetails,
                        note_to_rider: "",
                      })
                      }}
                    >
                      {_t(t("Remove"))}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      </div>

      {/*pre order bill*/}
      <div
        style={{ zIndex: 1039 }} 
        className={`modal fade ${orderDetails.pre_order_modal !== false ? "showing" : ""}`}
        id="preOrder"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">{orderDetails.is_advance_booking ? "Advance Booking" : "Pre Order"}</div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => setOrderDetails({...orderDetails,pre_order_date: null,pre_order_modal:false,advance_amount: 0,is_advance_booking: 0, payment_type: null})}
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              <form onSubmit={(e) => orderDetails.is_advance_booking ? handleSubmitOrder(e) : handlePreOrder(e)}  autoComplete="off" >
                <label htmlFor="date" className="form-label">
                  Select Date/Time <span style={{color:"red"}}>*</span>
                </label>
                <DatePicker
                  selected={orderDetails.pre_order_date}
                  onChange={(date) => setOrderDetails((curr)=>({...curr, pre_order_date: date}))}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  minDate={now}
                  minTime={minTime}
                  maxTime={endOfDay}
                  showTimeSelect
                  dropdownMode="select"
                  dateFormat="Pp"
                  className="form-control sm-text py-2 preOrder_date"
                  placeholderText={_t(t("Select Date/Time"))}
                  timeIntervals={15}
                  // withPortal
                />
                
                {
                  orderDetails.is_advance_booking ? (
                    <>
                      <label htmlFor="amount" className="form-label mt-3">
                        Enter Advance Amount
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          disabled = {orderDetails.payment_type && orderDetails.payment_type.length > 0}
                          className="form-control"
                          id="amount"
                          name="amount"
                          min="0"
                          onWheel={(e) => e.target.blur()} 
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          placeholder="Enter Amount"
                          value={orderDetails?.advance_amount ?? ""}
                          required
                          onChange={(e) => setOrderDetails({...orderDetails, advance_amount: e.target.value})}
                        />
                        <div className="ml-2 lg-text" title="Unlock amount field">
                          <i className="fa fa-close cursor-pointer" onClick={()=> setOrderDetails((curr)=>({...curr, payment_type: null}))}></i>
                        </div>
                      </div>
                      <div className="row bill_modal_scroll mt-2" style={{maxHeight: "6rem"}}>
                        {paymentTypeAvailable && paymentTypeAvailable.map((payment)=>{
                            return (
                              <div className="col-6 text-truncate my-1">
                                <input
                                  className="form-check-input pointer-cursor"
                                  type="radio"
                                  id={`payment_${payment.id}`}
                                  name="payment_discount"
                                  checked={orderDetails.payment_type && orderDetails.payment_type[0]?.id === payment.id}
                                  onChange={(e) => {
                                    setOrderDetails((curr)=>({...curr, payment_type: [{...payment, bill_amount: Number(orderDetails.advance_amount),}]}))
                                  }}
                                />
                                <label
                                  className="form-radio-label d-inline pointer-cursor ml-1"
                                  htmlFor={`payment_${payment.id}`}
                                >
                                  {_t(t(`${payment.name}`))}
                                </label>
                              </div>  
                            )
                          })
                        }
                      </div>
                    </>
                  ) : ""
                }
                <div className="mt-3 mb-1">
                  <div className="row d-flex justify-content-center w-100 m-0">
                    <div className="col-4">
                      <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded-25"
                        data-dismiss="modal"
                      >
                        {_t(t("Submit"))}
                      </button>
                    </div>
                    <div className="col-4">
                      <button
                        type="button"
                        disabled={loading}
                        className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded-25"
                        data-dismiss="modal"
                        onClick={(e) => {
                          e.stopPropagation()
                          setOrderDetails((curr)=>({...curr, pre_order_date: null, pre_order_modal:false, advance_amount: 0, is_advance_booking: 0, payment_type: null}))
                        }}
                      >
                        {_t(t("Remove"))}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


      {/* Customer History Modal */}
      <div
        style={{ zIndex: 9999 }} 
        className={`modal fade ${orderDetails?.newCustomerInfo && orderDetails.newCustomerInfo.modal ? "showing" : ""}`}
        id="customerHistoryModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg px-1 mt-0">
          <div className="modal-content">
            <div className="modal-header align-items-center p-2 px-3">
              <h5 className="modal-title font-weight-bold">{orderDetails.newCustomerInfo?.name || "Customer History"}</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => setOrderDetails((curr)=>({...curr, newCustomerInfo: { ...curr.newCustomerInfo, modal: false }}))}
              ></button>
            </div>
            <div className="modal-body p-0">
               <div className="table-responsive mx-3 bill_modal_scroll"  style={{ maxHeight: "calc(100vh - 18rem)" }}>
                 <table className="table table-hover mb-0">
                   <thead className="bg-light">
                     <tr>
                       <th className="border-0 font-weight-bold">Order ID/Name</th>
                       <th className="border-0 font-weight-bold"><i className="fa fa-calendar-alt mr-1"></i> Date</th>
                       <th className="border-0 font-weight-bold">Qty/Status</th>
                       <th className="border-0 font-weight-bold">Total</th>
                     </tr>
                   </thead>
                   <tbody>
                      {orderDetails.newCustomerInfo?.order ? (
                        <React.Fragment>
                          <tr>
                            <td className="text-success font-weight-bold p-1">{orderDetails.newCustomerInfo.order.id}</td>
                            <td className="p-1">{orderDetails.newCustomerInfo.order.order_date}</td>
                            <td className="p-1">
                              <span className={getStatusBadge(orderDetails.newCustomerInfo.order)}>
                                {parseInt(orderDetails.newCustomerInfo.order?.is_cancelled) === 0 ? (
                                [
                                  parseInt(orderDetails.newCustomerInfo.order?.is_paid) === 1 &&
                                  parseInt(orderDetails.newCustomerInfo.order?.is_refund) === 0 ? (
                                    <span>
                                      Paid
                                    </span>
                                    ) : parseInt(orderDetails.newCustomerInfo.order?.is_refund) === 1 ? (
                                    <span >
                                      Refund
                                    </span>
                                    ) : (
                                    <span>
                                      processing
                                    </span>
                                  ),
                                ]
                                ) : (
                                <span>
                                  Cancelled
                                </span>
                                )}
                              </span>
                            </td>
                            <td className="p-1">{currencySymbolLeft()} {orderDetails.newCustomerInfo.order.total_payable}</td>
                          </tr>
                          {/* Items Row - Simplified for now based on image */}
                          {orderDetails.newCustomerInfo?.order.order_item?.length && orderDetails.newCustomerInfo.order.order_item.map((item, index) => (
                            <>
                              <tr key={index} className="bg-light">
                                <td className="p-1" colSpan="2">
                                  <span> {item.food_item} {item.variation ? `- ${item.variation}` : ""} </span>
                                </td>
                                <td className="text-muted p-1">Qty: {item.quantity}</td>
                                <td className="p-1">{currencySymbolLeft()} {item.price}</td>
                              </tr>
                              {item.properties && JSON.parse(item.properties)?.length ? JSON.parse(item.properties).map((prp,i)=>(
                                <tr key={i} className="bg-light p-1">
                                  <td colSpan="2" className="p-1 pl-2">
                                    <span>{prp.property} <span className="badge badge-warning p-1">Prp</span></span>
                                  </td>
                                  <td className="text-muted p-1">Qty: {prp.quantity}</td>
                                  <td>
                                    {currencySymbolLeft()} {prp.price_per_qty}
                                  </td>
                                </tr>
                              )) : ""}
                            </>
                          ))}
                        </React.Fragment>
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-4 text-muted">No order history found</td>
                        </tr>
                      )}

                   </tbody>
                 </table>
               </div>
            </div>
             <div className="modal-footer border-top-0 d-flex justify-content-end">
                <button 
                  type="button" 
                  className="btn btn-secondary rounded-sm" 
                  onClick={(e) => setOrderDetails((curr)=>({...curr, newCustomerInfo: { ...curr.newCustomerInfo, modal: false }}))}
                >
                  Close
                </button>
                <button 
                  type="button" 
                  className="btn btn-success rounded-sm" 
                  onClick={confirmPunchOrder}
                  disabled={loading}
                >
                  Punch Order
                </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default memo(PosModal);
